import type { AssignedAgentsQueryData } from "web_myplann/Api/Advisor/Types/AssignedAgentsQueryData";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const addConnectedAdvisorToCache = (
	cached: AssignedAgentsQueryData | undefined,
	advisor: AgentAssignedListItemResponseDTO | undefined,
) => {
	if (!cached || !advisor) return undefined;

	return {
		...cached,
		data: [...cached.data, advisor],
		meta: {
			...cached.meta,
			totalCount: cached.meta.totalCount + 1,
		},
	};
};
